<div class="finance-list-page bulk-cost-defaults-page">
  <app-page-shell>
    <p-toast position="top-center"></p-toast>
    <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

    <app-page-hero eyebrow="Payables" title="Bulk Cost Account Defaults"
      subtitle="Set the debit expense and credit payable or clearing account applied when a bulk cost has no explicit accounting selection.">
      <div actions>
        <p-button label="Back to Bulk Costs" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (click)="back()"></p-button>
      </div>
    </app-page-hero>

    <app-page-data-panel title="Source Type Defaults" subtitle="Defaults are company scoped. Explicit accounts on bulk cost headers and lines always take priority."
      resultText="{{ rows.length }} source types">
      <div class="defaults-intro">
        <i class="pi pi-info-circle"></i>
        <span>Debit defaults populate new cost lines. Credit defaults populate the document payable or internal clearing account.</span>
      </div>

      <div class="default-card" *ngFor="let row of rows">
        <div class="default-card-heading">
          <div>
            <span class="eyebrow">Source Type</span>
            <h3>{{ sourceLabel(row.sourceType) }}</h3>
          </div>
          <p-tag value="Active" severity="success"></p-tag>
        </div>

        <div class="defaults-grid">
          <div class="field">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-arrow-down-left"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select [inputId]="'debit-' + row.sourceType" [options]="accounts" [(ngModel)]="row.defaultDebitAccountId"
                  optionLabel="accountName" optionValue="accountId" [filter]="true" filterBy="accountCode,accountName"
                  [showClear]="true" appendTo="body" styleClass="w-full">
                  <ng-template let-account pTemplate="item"><span>{{ accountLabel(account) }}</span></ng-template>
                </p-select>
                <label [for]="'debit-' + row.sourceType">Default Debit Expense Account</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>

          <div class="field">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-arrow-up-right"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select [inputId]="'credit-' + row.sourceType" [options]="accounts" [(ngModel)]="row.defaultCreditAccountId"
                  optionLabel="accountName" optionValue="accountId" [filter]="true" filterBy="accountCode,accountName"
                  [showClear]="true" appendTo="body" styleClass="w-full">
                  <ng-template let-account pTemplate="item"><span>{{ accountLabel(account) }}</span></ng-template>
                </p-select>
                <label [for]="'credit-' + row.sourceType">Default Credit / Clearing Account</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>

          <div class="default-card-action">
            <p-button label="Save Defaults" icon="pi pi-save" size="small" [loading]="isSaving" (click)="save(row)"></p-button>
          </div>
        </div>
      </div>
    </app-page-data-panel>
  </app-page-shell>
</div>
